import React, { useMemo } from "react";
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Badge, Table, Row, Col, Card, CardBody, Spinner,
} from "reactstrap";
import { generateProclamationPDF } from "./ProclamationPDF";

const ProclamationResultsModal = ({
    isOpen, 
    toggle,
    proclamationResults = [],
    ueColumns = [],
    sessionInfo = null,
    loadingProclamation = false,
    studyLevelName = ""
}) => {

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
            <ModalHeader toggle={toggle}>
                📣 Résultats de la Proclamation
            </ModalHeader>

            <ModalBody>
                {loadingProclamation ? (
                    <div className="text-center py-4">
                        <Spinner color="primary" />
                        <div className="mt-2 text-muted">Chargement...</div>
                    </div>
                ) : (
                    <>
                        {/* --- EN-TÊTE INFOS SESSION & EVALUATION --- */}
                        <Card className="bg-light border-0 mb-3">
                            <CardBody className="py-2">
                                <Row className="align-items-center text-center text-md-start">
                                    <Col md={6} className="border-end-md">
                                        <div className="text-muted small text-uppercase fw-bold">Session</div>
                                        <h5 className="mb-0 text-primary">{sessionInfo?.label || "N/A"}</h5>
                                        <small className="text-muted">Année : {sessionInfo?.academic_year || "N/A"}</small>
                                    </Col>
                                    <Col md={6} className="mt-2 mt-md-0">
                                        <div className="text-muted small text-uppercase fw-bold">Évaluation</div>
                                        <h5 className="mb-0 text-dark">
                                            {sessionInfo?.evaluation_title || "Examen de session"}
                                        </h5>
                                        <Badge color="info" pill>
                                            {sessionInfo?.semester ? `Semestre ${sessionInfo.semester}` : "N/A"}
                                        </Badge>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* TABLEAU DYNAMIQUE */}
                        <div style={{ maxHeight: "450px", overflowY: "auto" }}>
                            <Table bordered size="sm" responsive hover>
                                <thead className="table-light sticky-top">
                                    <tr>
                                        <th className="text-center">#</th>
                                        <th>Matricule</th>
                                        <th>Nom</th>
                                        <th>Prénom</th>
                                        <th className="text-center">Sexe</th>
                                        
                                        {/* Colonnes dynamiques UE */}
                                        {ueColumns.map((ue) => (
                                            <th key={ue.ue_id} className="text-center" style={{ minWidth: "100px" }}>
                                                {ue.ue_label}
                                            </th>
                                        ))}
                                        
                                        <th className="text-center">Moyenne</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {proclamationResults.length === 0 ? (
                                        <tr>
                                            <td colSpan={6 + ueColumns.length} className="text-center text-muted py-3">
                                                Aucun résultat trouvé
                                            </td>
                                        </tr>
                                    ) : (
                                        proclamationResults.map((r, i) => (
                                            <tr key={i}>
                                                <td className="text-center fw-bold">{i + 1}</td>
                                                <td className="font-monospace small">
                                                    {r.student?.student_number ?? "-"}
                                                </td>
                                                <td className="fw-bold">
                                                    {r.student?.last_name ?? "-"}
                                                </td>
                                                <td>{r.student?.first_name ?? "-"}</td>
                                                <td className="text-center">{r.student?.sex ?? "-"}</td>

                                                {/* Notes dynamiques par UE */}
                                                {ueColumns.map((ue) => {
                                                    const notes = r.ue_notes || [];
                                                    const found = notes.find((n) => n.ue_id === ue.ue_id);
                                                    const moyenne = found?.moyenne;

                                                    if (moyenne === null || moyenne === undefined) {
                                                        return <td key={ue.ue_id} className="text-center">-</td>;
                                                    }

                                                    return (
                                                        <td key={ue.ue_id} className="text-center">
                                                            <span style={{
                                                                color: parseFloat(moyenne) >= 10
                                                                    ? "var(--bs-success)"
                                                                    : "var(--bs-danger)",
                                                                fontWeight: 500,
                                                            }}>
                                                                {parseFloat(moyenne).toFixed(2)}
                                                            </span>
                                                        </td>
                                                    );
                                                })}

                                                {/* Moyenne générale */}
                                                <td className="text-center">
                                                    <Badge color={parseFloat(r.moyenne) >= 10 ? "success" : "danger"}>
                                                        {parseFloat(r.moyenne).toFixed(2)}/20
                                                    </Badge>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </>
                )}
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" outline onClick={toggle}>
                    Fermer
                </Button>
                <Button
                    color="success"
                    disabled={proclamationResults.length === 0 || loadingProclamation}
                    onClick={() => generateProclamationPDF({
                        results: proclamationResults,
                        sessionInfo: sessionInfo, // Contient evaluation_title, label, academic_year
                        ueColumns: ueColumns,
                        studyLevelName: studyLevelName
                    })}
                >
                    📄 Générer PDF
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ProclamationResultsModal;